<template>
  <val-set-box>
    <el-button type="danger" class="del-ar-item-child" icon="el-icon-delete" circle
      @click="() => { $emit('delArItem') }" size="mini" v-show="length > 1"></el-button>
    <div class="aaic-item">
      <div class="flex-a-c">
        <div style="font-size: 14px;color: #606266;padding-right: 10px;">
          {{ $t('csce17') }}
        </div>
        <el-input-number size="mini" v-model="playCount" :min="1"
          @change="(val) => { changeValue('playCount', val) }"></el-input-number>
      </div>
      <div class="flex-a-c">
        <div style="font-size: 14px;color: #606266;padding-right: 10px;">
          {{ $t('csce18') }}
        </div>
        <el-input-number size="mini" v-model="allNumber" :min="0"
          @change="(val) => { changeValue('allNumber', val) }"></el-input-number>
      </div>
    </div>
    <div class="aaic-item">
      <div style="font-size: 14px;color: #606266;">
        {{ $t('cdck10') }}
      </div>
      <el-time-picker size="mini" is-range v-model="playTime" :range-separator="$t('ctce5')"
        :start-placeholder="$t('ctce4')" :end-placeholder="$t('ctce6')" :placeholder="$t('actd1')"
        @change="(val) => { changeValue('playTime', val) }">
      </el-time-picker>
    </div>
    <div class="aaic-item">
      <el-radio-group v-model="isDateLimit" @change="(val) => { changeValue('isDateLimit', val) }">
        <el-radio :label="0">{{
          $t('terminal.noLimit') }}</el-radio>
        <el-radio :label="1">{{
          $t('terminal.speDate') }}</el-radio>
      </el-radio-group>

      <el-date-picker style="width: 386px;" :disabled="isDateLimit == 0" v-model="playDate" type="daterange"
        :range-separator="$t('ctce5')" :start-placeholder="$t('ctce4')" :end-placeholder="$t('ctce6')" size="mini"
        @change="(val) => { changeValue('playDate', val) }">
      </el-date-picker>
    </div>
    <div class="aaic-item">
      <el-radio-group v-model="isWeekLimit" @change="(val) => { changeValue('isWeekLimit', val) }">
        <el-radio :label="0">{{
          $t('terminal.noLimit') }}</el-radio>
        <el-radio :label="1">{{
          $t('terminal.speWeek') }}</el-radio>
      </el-radio-group>

      <el-checkbox-group v-model="validWeek" :disabled="isWeekLimit == 0" size="mini"
        @change="(val) => { changeValue('validWeek', val) }">
        <el-checkbox-button v-for="week in weeks" :label="week" :key="week">{{ $t(week_intl[week]) }}
        </el-checkbox-button>
      </el-checkbox-group>
    </div>
  </val-set-box>
</template>

<script>
import ValSetBox from './items/ValSetBox';
import { weekFormatting, reWeekFormatting, dateFormatting, timeFormatting, reTimeFormatting, reDateFormatting } from "@/assets/scripts/dateFormatting";
const weeks = ['一', '二', '三', '四', '五', '六', '日'];

const week_intl = { '一': 'terminal.Monday', '二': 'terminal.Tuesday', '三': 'terminal.Wednesday', '四': 'terminal.Thursday', '五': 'terminal.Friday', '六': 'terminal.Saturday', '日': 'terminal.Sunday' };

export default {
  name: "Tpchild",
  props: {
    arItem: {
      type: Object,
      default: () => {
        return {}
      }
    },
    length: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      playCount: 1,
      allNumber: 1,
      playTime: [],
      isDateLimit: 0,
      playDate: '',
      isWeekLimit: 0,
      validWeek: [],
      weeks,
      week_intl,
      timeoutId: 0
    }
  },
  created() {
    this.init(this.arItem);
  },
  methods: {
    init(data) {
      const { playCount, allNumber, startTime, endTime, isDateLimit, dateStart, dateEnd, isWeekLimit, validWeek } = data;
      this.playCount = playCount;
      this.allNumber = allNumber;
      this.isDateLimit = isDateLimit;
      this.isWeekLimit = isWeekLimit;
      this.playTime = [reTimeFormatting(startTime), reTimeFormatting(endTime)];
      this.playDate = [reDateFormatting(dateStart), reDateFormatting(dateEnd)];
      this.validWeek = reWeekFormatting(validWeek);
    },
    changeValue(key, value) {
      let data = {};
      switch (key) {
        case 'playTime': {
          const [startTime, endTime] = value;
          data = {
            startTime: timeFormatting(startTime),
            endTime: timeFormatting(endTime)
          };
        }
          break;
        case 'playDate': {
          const [dateStart, dateEnd] = value;
          data = {
            dateStart: dateFormatting(dateStart),
            dateEnd: dateFormatting(dateEnd)
          };
        }
          break;
        case 'validWeek':
          data = { validWeek: weekFormatting(value) };
          break;
        case 'playCount':
        case 'allNumber':
        case 'isDateLimit':
        case 'isWeekLimit':
          data = { [key]: value };
          break;
        default:
          break;
      }

      if (this.timeoutId) {
        clearTimeout(this.timeoutId);
        this.timeoutId = 0;
      }

      this.timeoutId = setTimeout(() => {
        this.$http.post("/admin/AdvancedRelease/editArTimerplay", {
          id: this.arItem.id, ...data
        }, data => {
          console.log(data);
        });
      }, 500);

      this.$emit('editArItem', data);
    }
  },
  watch: {
    arList: {
      handler(nd) {
        this.init(nd);
      }
    }
  },
  components: {
    ValSetBox
  }
}
</script>


<style lang="scss" scoped>
.del-ar-item-child {
  position: absolute;
  top: 4px;
  right: 4px;
}

.aaic-item {
  margin: 8px 0px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}
</style>